<div class="avatar" [ngStyle]="{
  'width.px': size,
  'height.px': size,
  'background-color': color[1],
  'border-color': color[0],
  'border-width.px': border ? 1 : 0
}">
  <span [ngStyle]="{ 'font-size.px': textSize, color: color[0] }" *ngIf="symbol">{{symbol}}</span>
</div>
